import { getCookie } from "cookies-next";

export const isDev = process.env.isDev === "true";
export const isStage = process.env.isStage === "true";
export const isProd = process.env.isProd === "true";

export const adyenVersion = "3.18.2";

export const locales = process.env.NEXT_PUBLIC_SUPPORTED_LOCALES.split(",");
export const gtmId = process.env.NEXT_PUBLIC_GTM_ID;
export const googleSiteVerification =
  process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION;

export const exponeaInitConfig = {
  target: "https://api.exponea.com",
  token: process.env.NEXT_PUBLIC_EXPONEA_TOKEN,
  ping: {
    enabled: false,
  },
};

export const exponeaStartConfig = {
  track: {
    visits: false,
  },
};

const getExponea = () => {
  return process.title === "node" ? "" : window.exponea;
};

export const validToUseExponea = () => getExponea();

export const defaultLocale = process.env.NEXT_PUBLIC_DEFAULT_LOCALE;

export const localeCountry = {
  en: "en_US",
  ru: "ru_RU",
  et: "et_EE",
  lt: "lt_LT",
  lv: "lv_LV",
  pl: "pl_PL",
};

export const countries = {
  ee: "Estonia",
  ru: "Russia",
  lv: "Latvia",
  lt: "Lithuania",
  pl: "Poland",
  // fi: 'Finland'
};

export const blurDataURL = "/static/images/common/preview.jpg";

export const showFaqForLocales = ["et", "en", "lv", "ru", "pl"];
export const showSchoolsForLocales = ["et", "ru"];

export const currencies = [
  {
    Currency: "CURRENCY.EUR",
    CurrencyName: "EUR",
    Symbol: "€",
  },
  {
    Currency: "CURRENCY.RUB",
    CurrencyName: "RUB",
    Symbol: "₽",
  },
  // {
  //   Currency: "CURRENCY.BYN",
  //   CurrencyName: "BYN",
  //   Symbol: "Br",
  // },
  {
    Currency: "CURRENCY.PLN",
    CurrencyName: "PLN",
    Symbol: "zł",
  },
];

export const currenciesByCode = {
  EUR: {
    Currency: "CURRENCY.EUR",
    CurrencyName: "EUR",
    Symbol: "€",
  },
  RUB: {
    Currency: "CURRENCY.RUB",
    CurrencyName: "RUB",
    Symbol: "₽",
  },
  PLN: {
    Currency: "CURRENCY.PLN",
    CurrencyName: "PLN",
    Symbol: "zł",
  },
};

export const tokenVerificationInterval = 100;

export const LOADING_SKELETON_CONFIG = {
  delay: 0.7,
  duration: 1.2,
  baseColor: "#E9E9E9",
  highlightColor: "#fff",
};

export const defaultRegion = "ee";

export const PAYMENT_STATUSES = {
  error: "error",
  success: "success",
  basketPaid: "basketPaid",
  paymentProcessing: "paymentProcessing",
  initializationError: "initializationError",
};

export const PAYMENT_PRODUCT_TYPES = {
  tickets: "tickets",
  giftCard: "giftCard",
  changeTickets: "changeTickets",
};

export const PAYMENT_TYPES = {
  zero: "zero",
  adyen: "adyen",
  neopay: "neopay",
  bankLink: "bankLink",
  montonio: "montonio",
  corporateclient: "corporateclient",
};

export const purchasingProcessRoutes = [
  "/tickets/seat-details",
  "/tickets/passenger-details",
  "/tickets/extras",
  "/tickets/payment",
  "/tickets/thanks",
  "/change-tickets/search",
  "/change-tickets/seat-details",
  "/change-tickets/payment",
  "/change-tickets/thanks",
  "/payment",

  // "/tickets/seat-details/",
  // "/tickets/passenger-details/",
  // "/tickets/extras/",
  // "/tickets/payment/",
  // "/tickets/thanks/",
  // "/change-tickets/search/",
  // "/change-tickets/seat-details/",
  // "/change-tickets/payment/",
  // "/change-tickets/thanks/",
  // "/payment/",
];

const searchRoutes = ["/tickets/search", "/tickets/search/"];

export const checkIsPurchasFlowPage = (path) => {
  return [...purchasingProcessRoutes, ...searchRoutes].includes(
    path.toLowerCase().replace(/\/$/, ""),
  );
};

export const checkIsPurchasingProcess = (path) => {
  return purchasingProcessRoutes.includes(
    path.toLowerCase().replace(/\/$/, ""),
  );
};

export const checkIsProfilePage = (path) => {
  return path.startsWith("/profile/");
};

export const sortTicketOptions = {
  transfers: {
    id: "transfers",
    translateKey: "sorting.default",
  },
  price: {
    id: "price",
    translateKey: "sorting.price",
  },
  time: {
    id: "time",
    translateKey: "sorting.tripTime",
  },
};

export const FILE_TYPES = {
  video: "video",
  image: "image",
  threeD: "threeD",
};

export const VIDEO_MAX_SIZE = 20 * 1024 * 1024; // 20MB
export const IMAGE_MAX_SIZE = 10 * 1024 * 1024; // 10MB
export const THREE_D_MAX_SIZE = 50 * 1024 * 1024; // 50MB

export const allowedVideoExtensions = ["mp4", "mov", "webm"];

export const isVideoExtension = (extension) =>
  allowedVideoExtensions.some((ext) => extension.endsWith(ext));

export const allowedImageExtensions = ["png", "jpeg", "jpg"];

export const isImageExtension = (extension) =>
  allowedImageExtensions.some((ext) => extension.endsWith(ext));

export const allowedThreeDExtensions = ["glb"];

export const isThreeDExtension = (extension) =>
  allowedThreeDExtensions.some((ext) => extension.endsWith(ext));

export const FARE_CLASSES = {
  adult: "BONUS_SCHEME_GROUP.ADULT",
  children: "BONUS_SCHEME_GROUP.CHILDREN",
  pupil: "BONUS_SCHEME_GROUP.STUDENTS",
  disabled: "BONUS_SCHEME_GROUP.HANDICAP",
  other: "BONUS_SCHEME_GROUP.OTHER",
  other2: "BONUS_SCHEME_GROUP.OTHER2",
  other3: "BONUS_SCHEME_GROUP.OTHER3",
  young: "BONUS_SCHEME_GROUP.THE_YOUNG",
  pet: "BONUS_SCHEME_GROUP.PET",
  senior: "BONUS_SCHEME_GROUP.THE_ELDERLY",
};

export const FARE_CLASSES_SORTING_ORDER = [
  FARE_CLASSES.adult,
  FARE_CLASSES.young,
  FARE_CLASSES.pupil,
  FARE_CLASSES.senior,
  FARE_CLASSES.children,
  FARE_CLASSES.disabled,
  FARE_CLASSES.pet,
  FARE_CLASSES.other,
  FARE_CLASSES.other2,
  FARE_CLASSES.other3,
];

export const zendeskPages = [
  "transportation-rules",
  "ticket-sales-rules",
  "privacy-policy",
  "terms-of-use",
];
